module.exports = __webpack_public_path__ + "static/img/11.8d5cd2a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/4/zh/11.png
// module id = w4n5
// module chunks = 0